import { Controller } from "@hotwired/stimulus";
import { Turbo } from "@hotwired/turbo-rails";
import buildShouldExcludeKey from '../utils/build_should_exclude_key';

export default class FrameSwitcherController extends Controller {
  static values = {
    url: String,

    /**
     * autosave から除外する key のリスト。
     * / で始まり / で終わる文字列を指定すると、その中身が正規表現と解釈される。
     * この正規表現には ^ と $ が付与され、 key 全体にマッチするか評価される。
     * @example ["/example\\[.+/", "foo[bar][buzz]"]
     */
    except: { type: Array, default: [] }
  };

  switch({ params: { frame } }) {
    const url  = new URL(this.urlValue, location.origin);
    const form = new FormData(this.element);
    const shouldExcludeKey = buildShouldExcludeKey(this.exceptValue);
    const excludedKeys     = Array.from(form.keys()).filter(shouldExcludeKey);

    for (const [k, v] of form.entries()) {
      if (v instanceof File) {
        form.delete(k);
      }
    }

    for (const k of excludedKeys) {
      form.delete(k);
    }

    url.search = new URLSearchParams(form).toString();

    Turbo.visit(url, { frame });
  }
}
